/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Helmet } from 'react-helmet';

import { markAsRead } from '../actions/actions';

import CategoryImage, { getCategoryImage } from '../components/CategoryImage';

import Map from '../components/Map';

class ReportDetail extends React.Component {
  componentDidMount() {
    this.props.markAsRead(this.props.match.params.reportID);
    window.scrollTo(0, 0);
  }
  shareOnFacebook = event => {
    event.preventDefault();
    FB.ui(
      {
        method: 'share',
        mobile_iframe: true,
        href: document.location.href,
      },
      () => {},
    );
  };
  render() {
    const { report } = this.props;
    if (!report) {
      return null;
    }
    return (
      <div className="ReportDetail">
        <Helmet>
          <meta name="description" content={report.shortDescription} />
          <meta property="og:url" content={document.location.href} />
          <meta property="og:title" content={report.title} />
          <meta property="og:image" content={getCategoryImage('red', report.categoryIcon).url} />
          <meta property="og:description" content={report.shortDescription} />
        </Helmet>
        <div className="ReportDetail-header">
          <div className="ReportDetail-icon">
            <CategoryImage category={report.categoryIcon} />
          </div>
          <div className="ReportDetail-info">
            <h3 className="ReportDetail-title">{report.title}</h3>
            <div className="ReportDetail-meta">
              {report.location}, <br />
              {moment(report.validFrom, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm [Uhr]')}
            </div>
          </div>
        </div>
        <Map report={report} />
        <p
          className="ReportDetail-description"
          dangerouslySetInnerHTML={{ __html: report.fullDescription }}
        />
        <div className="ReportDetail-sender">
          <b>Absender der Meldung:</b> <br />
          {report.sender}
        </div>
        <div className="ReportDetail-share">
          <b>Meldung teilen:</b> <br />
          <div className="SocialIcons">
            <a href="#0" onClick={this.shareOnFacebook} target="_blank" className="SocialIcon">
              <img
                className="SocialIcon-image"
                src="/images/social/facebook.png"
                alt="Auf Facebook teilen"
              />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?text=${report.shortDescription}&url=${
                document.location.href
              }`}
              target="_blank"
              className="SocialIcon"
            >
              <img
                className="SocialIcon-image"
                src="/images/social/twitter.png"
                alt="Auf Twitter teilen"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

ReportDetail.propTypes = {
  report: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  markAsRead: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const report = state.reports.filter(
    item => parseInt(ownProps.match.params.reportID, 10) === item.id,
  )[0];
  return {
    report,
  };
};

const mapDispatchToProps = dispatch => ({
  markAsRead: id => {
    dispatch(markAsRead(id));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportDetail);



// WEBPACK FOOTER //
// ./src/js/routes/ReportDetail.js